<template>
    <div
      class="chat-bot-container chat-bot-help-container"
      :class="viewHasSidebar ? 'chatbot-help-container-sidenavbar' : ''">
      <div class="chat-bot-helper-header">
        <div class="header">
          <span class="title">Omniview AI Helper</span>
          <div class="close-chat-bot" @click="closeChatbotHelp"></div>
        </div>
        <span class="subtitle">Things I can help you</span>
      </div>
      <!-- <div class="">
        <span>I can offer you information about the SBO platform.</span>
      </div> -->
      <div class="chat-bot-helper-charts">
        <div class="chat-bot-helper-title-section">To request a chart the required information is:</div>
        <div class="charts-mandatory charts-explanation-options">
          <span class="type">Chart Type</span>
          <span class="model">Model</span>
          <span class="field">Field</span>
          <span class="filters">Filters</span>
        </div>
        <div class="chat-bot-help-btn charts-explanation-options" @click="getHowRequestChart">
          generate a
          <span class="type">bar chart</span>
          of
          <span class="model">alarms</span>
          by
          <span class="field">status canceled</span>
          <span>, </span>
          <span class="filters">from the last two weeks</span>
        </div>
        <div class="more-examples">
          <div class="chat-bot-helper-title-section">Here is more examples:</div>
          <div class="examples">
            <span class="chat-bot-help-btn" @click="getListOfAlarms">list of Detection events</span>
            <span class="chat-bot-help-btn" @click="getHeatMapOfAlarms">Heat map of alarms</span>
            <span class="chat-bot-help-btn" @click="getMoreExamplesOfCharts">More</span>
          </div>
        </div>
        <div class="specific-information">
          <div class="chat-bot-helper-title-section">if you need specific information for charts on each model you can click here.</div>
          <div class="models-information">
            <span class="chat-bot-help-btn" @click="getHowRequestSpecificChart('alarms')">Alarms</span>
            <span class="chat-bot-help-btn" @click="getHowRequestSpecificChart('detection events')">Detection Events</span>
            <span class="chat-bot-help-btn" @click="getHowRequestSpecificChart('cameras')">Cameras</span>
            <span class="chat-bot-help-btn" @click="getHowRequestSpecificChart('intelexvision')">Intelexvision / Analytics Records</span>
          </div>
        </div>
      </div>
      <div class="chat-bot-helper-platafform">
        <div class="chat-bot-helper-title-section">I can also help you with information about the SBO platform:</div>
        <div class="platafform-information">
          <span class="chat-bot-help-btn" @click="getSboInformation">SBO Plataform</span>
          <span class="chat-bot-help-btn" @click="getHowAddOmnicloudCamera">Add a omnicloud camera</span>
        </div>
      </div>
      <div class="final-message">
        <span>Check out our latest AI chatbot feature</span>
        <span class="comming">More to come, stay tuned!</span>
      </div>
    </div>
  </template>
  
  <script>
  import { computed } from "@vue/composition-api";
  import store from "@/store";
  import { useDefineChatbot } from "@/composables/defineChatbot";
  import { useChatbotHelp } from '@/composables/chatbotHelp'
  
  export default {
    components: {
    },
    props: {
    },
    setup(_, context) {
  
      const { viewHasSidebar } = useDefineChatbot()

      const {
        getHowRequestChart,
        getListOfAlarms,
        getHeatMapOfAlarms,
        getMoreExamplesOfCharts,
        getHowRequestSpecificChart,
        getSboInformation,
        getHowAddOmnicloudCamera,
        closeChatbotHelp
      } = useChatbotHelp()
  
      return {
        viewHasSidebar,
        getHowRequestChart,
        getListOfAlarms,
        getHeatMapOfAlarms,
        getMoreExamplesOfCharts,
        getHowRequestSpecificChart,
        getSboInformation,
        getHowAddOmnicloudCamera,
        closeChatbotHelp
      };
    },
  };
  </script>
  